const statementsHR = {
    "view": {
        "table": {
            "title": "Popis vaših izjava",
            "column": {
                "type": "Tip",
                "year": "Godina",
                "month": "Mjesec",
                "issue_year": "God. izdavanja",
                "issue_month": "Mj. izdavanja",
                "description": "Opis",
                "amount": "Iznos",
                "status": "Status",
                "details": "Detalji",
                "overview": "Pregled"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "label": {
                "status_open": "Otvoreno",
                "status_paid": "Plaćeno",
                "type_licensing": "Licenciranje",
                "type_regular": "Redovno",
                "type_audio_mastering_services": "Audio Mastering - Usluge",
                "type_vinyl_earnings": "Zarada od vinila",
                "type_offset": "Kompenzacija",
                "type_not_known": "Nepoznato",
                "month_january": "Siječanj",
                "month_february": "Veljača",
                "month_march": "Ožujak",
                "month_april": "Travanj",
                "month_may": "Svibanj",
                "month_june": "Lipanj",
                "month_july": "Srpanj",
                "month_august": "Kolovoz",
                "month_september": "Rujan",
                "month_october": "Listopad",
                "month_november": "Studeni",
                "month_december": "Prosinac"
            },
            "button": {
                "download": "Preuzmi",
                "exportCsv": "Izvoz CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Vaš trenutni plan pretplate ne podržava ovu značajku. Molimo <1>nadogradite</1> svoj plan pretplate kako biste koristili ovu značajku.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>nastavite</1> svoju pretplatu kako biste koristili ovu značajku.",
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte tim za podršku za više informacija."
        }
    }
};

export default statementsHR;